import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './Toast.module.scss';
import useAlert from '../../../hooks/useAlert';

const Toast = ({ toastMsgObj }) => {
  const { message, status } = toastMsgObj;
  const [setAlert] = useAlert();
  useEffect(() => {
    setTimeout(() => {
      setAlert({});
    }, 4000);
  }, []);
  return (
    <>
      <div
        className={`${styles.Toast} ${status ? styles.Toast__Sucess : styles.Toast__Error} animated fadeInUp faster`}
      >
        <div className={`${styles.ToastBox}`}>
          <div className={`${styles.ToastImage} csicon`} />
          <div className={`${styles.ToastText} font13 fw500 pl-8`}>{message}</div>
        </div>
      </div>
    </>
  );
};

export default Toast;

Toast.propTypes = {
  toastMsgObj: PropTypes.object,
};
